// extracted by mini-css-extract-plugin
module.exports = {"block":"StepInfo_block__2CCNG","icon":"StepInfo_icon__3DHjB","description":"StepInfo_description__32tTN","title":"StepInfo_title__EoapT"};